import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import _ from 'lodash';
import FiguresAndTablesForm from './FigureForm';
import { ISubmissionFileSet } from '@publishing-engine/domain/models/submission';
import { generateValidationSchema } from 'src/utils/validation';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FormFieldFiguresAndTables } from '@publishing-engine/domain/types/article';

export type IFigureValue = {
  fileSet: {
    FiguresAndTables: ISubmissionFileSet['FiguresAndTables'];
  };
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: IFigureValue) => void;
  formField: FormFieldFiguresAndTables;
  value?: ISubmissionFileSet['FiguresAndTables'];
  submissionContextId: string;
}

const FiguresAndTablesUpdateModal: React.FC<Props> = props => {
  const { isOpen, onClose, onSubmit, formField, submissionContextId } = props;

  const defaultValues = _.set(
    {} as IFigureValue,
    formField.caseDataFields.main,
    props.value
  );

  const schema = generateValidationSchema({
    FiguresAndTables: formField
  });

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(data => {
            onSubmit(data);
            onClose();
          })}
        >
          <Flex
            padding={8}
            gap={6}
            bgColor="surfacePrimaryFill"
            flexDirection="column"
            borderRadius="base"
          >
            <Flex maxHeight={700} overflow={'auto'}>
              <FiguresAndTablesForm
                config={formField}
                methods={methods}
                submissionContextId={submissionContextId}
              />
            </Flex>
            <Flex
              gap={2}
              justifyContent="flex-end"
              alignItems="center"
              alignSelf="stretch"
            >
              <Button
                variant="secondary"
                onClick={onClose}
                borderRadius="small"
              >
                Exit Without Saving
              </Button>
              <Button variant="primary" type="submit" borderRadius="small">
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default FiguresAndTablesUpdateModal;
